const createSvgFallback = (width, height, initial, bgColor = '#1e293b') => {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'><rect fill='${bgColor}' width='${width}' height='${height}'/><text x='50%' y='50%' font-size='${Math.floor(width / 3)}' fill='#ffffff' text-anchor='middle' dominant-baseline='middle' font-weight='bold'>${initial}</text></svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getMoviePosterUrl = (posterPath, movieTitle = null) => {
  if (posterPath) {
    if (posterPath.startsWith("data:image/") || posterPath.startsWith("http"))
      return posterPath;
    return posterPath.startsWith("/") ? posterPath : `/${posterPath}`;
  }
  const initial = movieTitle ? movieTitle.charAt(0).toUpperCase() : "M";
  return createSvgFallback(300, 450, initial);
};

export const getBackdropUrl = (backdropPath, posterPath, movieTitle = null) => {
  const imagePath = backdropPath || posterPath;
  if (imagePath) {
    if (imagePath.startsWith("data:image/") || imagePath.startsWith("http"))
      return imagePath;
    return imagePath.startsWith("/") ? imagePath : `/${imagePath}`;
  }
  const title = movieTitle || "Movie";
  const initial = title.charAt(0).toUpperCase();
  return createSvgFallback(1920, 1080, initial);
};

export const getCastImageUrl = (profilePath, actorName = null) => {
  if (profilePath) {
    if (profilePath.startsWith("data:image/") || profilePath.startsWith("http"))
      return profilePath;
    return profilePath.startsWith("/") ? profilePath : `/${profilePath}`;
  }
  const initial = actorName ? actorName.charAt(0).toUpperCase() : "A";
  return createSvgFallback(200, 300, initial, '#2a2d35');
};
